"use strict";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var _require = require('../../Error'),
    INVALID_ROW_COL = _require.INVALID_ROW_COL,
    OVERFLOW_ROW = _require.OVERFLOW_ROW,
    INVALID_MATRIX = _require.INVALID_MATRIX;
/**
 * Gets the row of a Matrix with valid index.
 * @memberof Matrix
 * @static
 * @param {Matrix} A - Any Matrix
 * @param {number} index - Any valid row index
 * @returns {Matrix} Row of A
 */


function row(A, index) {
  if (!(A instanceof this)) {
    throw new Error(INVALID_MATRIX);
  }

  if (!Number.isInteger(index) || index < 0) {
    throw new Error(INVALID_ROW_COL);
  }

  var _A$size = A.size(),
      _A$size2 = _slicedToArray(_A$size, 2),
      r = _A$size2[0],
      c = _A$size2[1];

  if (index >= r) {
    throw new Error(OVERFLOW_ROW);
  }

  var matrix = A._matrix;
  return this.generate(1, c, function (i, j) {
    return matrix[index][j];
  });
}

;
module.exports = row;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_slicedToArray, "_slicedToArray", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(_nonIterableRest, "_nonIterableRest", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(_unsupportedIterableToArray, "_unsupportedIterableToArray", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(_arrayLikeToArray, "_arrayLikeToArray", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(_iterableToArrayLimit, "_iterableToArrayLimit", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(_arrayWithHoles, "_arrayWithHoles", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(INVALID_ROW_COL, "INVALID_ROW_COL", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(OVERFLOW_ROW, "OVERFLOW_ROW", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(INVALID_MATRIX, "INVALID_MATRIX", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
  reactHotLoader.register(row, "row", "/home/yatham/Dev_BHS_Portal/node_modules/@rayyamhk/matrix/lib/core/utils/row.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();